import ScenariosPage from 'routes/Scenarios'
import { SCENARIO_TEMPLATES_REVALIDATE_TIME } from 'routes/constants'
import { fetchAllScenarios } from 'routes/Scenarios/helpers'
import { ScenarioTemplateCompact } from 'routes/Scenarios/helpers/types'

export default function WebsiteScenarios({
  scenarioTemplates,
}: {
  scenarioTemplates: ScenarioTemplateCompact[]
}) {
  return <ScenariosPage scenarioTemplates={scenarioTemplates} />
}

export async function getStaticProps() {
  const scenarioTemplates = await fetchAllScenarios()

  return {
    props: { scenarioTemplates },
    revalidate: SCENARIO_TEMPLATES_REVALIDATE_TIME,
  }
}
